import isDateInPast from './isDateInPast'

export const tsaPrecheckPromotionalPrice = Number(0.0).toFixed(2)

/** Current CLEAR+ bundle price (the legacy $209 rate is no longer used). */
const bundlePrice = 219
const PENDING_CONFIG = 'loading...'

export const formatPrice = (price: number, decimals: 0 | 1 | 2 = 0) =>
  `$${price.toFixed(decimals)}`

/** total amount of TPC & C+ bundled together */
export const getClearPlusBundlePricing = ({
  precheckPricing,
}: Partial<{
  precheckPricing: Partial<{
    enroll: number
    renewal: number
  }>
}>) => {
  const enrollmentPortion =
    typeof precheckPricing?.enroll === 'number'
      ? formatPrice(bundlePrice - precheckPricing.enroll)
      : PENDING_CONFIG
  const combinedEnroll =
    typeof precheckPricing?.enroll === 'number'
      ? formatPrice(precheckPricing.enroll + bundlePrice, 2)
      : PENDING_CONFIG

  const renewalPortion =
    typeof precheckPricing?.renewal === 'number'
      ? formatPrice(bundlePrice - precheckPricing.renewal)
      : PENDING_CONFIG
  const combinedRenewal =
    typeof precheckPricing?.renewal === 'number'
      ? formatPrice(precheckPricing.renewal + bundlePrice, 2)
      : PENDING_CONFIG

  /**
   * CLEAR+ first-year savings off the standard bundle price. Because the
   * discounted C+ price is (bundlePrice − precheck fee), the savings equal
   * the precheck fee itself. Whole dollars to match marketing copy
   * ($80 new / $70 renewal).
   */
  const enrollmentSavings = {
    raw: precheckPricing?.enroll,
    formatted:
      typeof precheckPricing?.enroll === 'number'
        ? formatPrice(precheckPricing.enroll)
        : PENDING_CONFIG,
  }
  const renewalSavings = {
    raw: precheckPricing?.renewal,
    formatted:
      typeof precheckPricing?.renewal === 'number'
        ? formatPrice(precheckPricing.renewal)
        : PENDING_CONFIG,
  }

  return {
    price: {
      raw: bundlePrice,
      formatted: {
        value: formatPrice(bundlePrice),
        diff: {
          enrollmentPortion,
          renewalPortion,
        },
        savings: {
          enrollment: enrollmentSavings,
          renewal: renewalSavings,
        },
        combined: {
          enroll: combinedEnroll,
          renewal: combinedRenewal,
        },
      },
    },
  }
}

export const isFamDiscountExpired = isDateInPast('2025-12-31')
